<div class="history-event" (click)="hasDetail ? toggleExpand.emit() : null" [class.clickable]="hasDetail">
    <div class="event-icon" [style.color]="entityConfig.color">
        <mat-icon>{{ entityConfig.icon }}</mat-icon>
    </div>
    <div class="event-content">
        <div class="event-label" [style.color]="entityConfig.color">{{ eventLabel }}</div>
        <div class="event-summary">{{ event.summary }}</div>
        <div class="event-meta">
            <span class="event-time">{{ event.occurredAt | date:'dd MMM yyyy, HH:mm' }}</span>
        </div>
    </div>
    <div class="event-expand" *ngIf="hasDetail">
        <mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </div>
</div>
<app-order-history-event-detail *ngIf="isExpanded && hasDetail" [event]="event"></app-order-history-event-detail>
